;
define("facets_category_cell.tpl", function(){});

